<div class="d-flex justify-content-end">
 <button class="btn btn-close"  mat-dialog-close>
  <i class="settings-close mdi mdi-close" ></i>
 </button>
</div>